export const getNewslettersListNextjsUrl = () => `/newsletters`
